module.exports = __webpack_public_path__ + "img/building-08.cf161533.svg";